import React from 'react'

const SvgDesc = props => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M5.333 26.667A5.334 5.334 0 0 1 0 21.333v-16A5.334 5.334 0 0 1 5.333 0h16a5.334 5.334 0 0 1 5.334 5.333A5.334 5.334 0 0 1 32 10.667v16A5.334 5.334 0 0 1 26.667 32h-16a5.334 5.334 0 0 1-5.334-5.333zm0-2.667V10.667a5.334 5.334 0 0 1 5.334-5.334H24a2.67 2.67 0 0 0-2.667-2.666h-16a2.67 2.67 0 0 0-2.666 2.666v16A2.67 2.67 0 0 0 5.333 24zm24-1.333v-12A2.67 2.67 0 0 0 26.667 8h-16A2.67 2.67 0 0 0 8 10.667v16a2.67 2.67 0 0 0 2.667 2.666h16a2.67 2.67 0 0 0 2.666-2.666v-4zm-6.666-8.001h-8c-.734 0-1.334-.6-1.334-1.333 0-.734.6-1.334 1.334-1.334h8A1.339 1.339 0 0 1 24 13.333c0 .733-.6 1.333-1.333 1.333zm0 5.334h-8c-.734 0-1.334-.6-1.334-1.333 0-.734.6-1.334 1.334-1.334h8c.733 0 1.333.6 1.333 1.334C24 19.4 23.4 20 22.667 20zm-5.334 5.333h-2.666c-.734 0-1.334-.6-1.334-1.333s.6-1.333 1.334-1.333h2.666c.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333z"
    />
  </svg>
)

export default SvgDesc
